<template>
    <div class="z-filter">
        <div class="z-filter__title-wrapper row u-align-center u-collapse--all">
            <z-caption tag="h2" size="xl" class="z-filter__title u-collapse--all">
                {{ name }}
            </z-caption>

            <div @click="expanded = !expanded" class="z-filter__toggle-label">
                <z-caption tag="span" size="xs">
                    {{ expanded ? textLocales.hide : textLocales.show }} {{ textLocales.filters }}
                </z-caption>

                <z-icon
                    :width="30"
                    :height="30"
                    :dir="expanded ? 'up' : 'down'"
                    name="arrows/round-arrow-big"
                    class="u-ml-3xs"></z-icon>
            </div>
        </div>

        <transition name="slide-down">
            <div v-show="expanded">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { localize } from '@/utils/i18n'

defineProps({
    name: String
})

const textLocales = {
    hide: localize({
        ru: 'Свернуть',
        en: 'Hide',
        cn: '折叠筛选条件'
    }),
    show: localize({
        ru: 'Развернуть',
        en: 'Show',
        cn: '展开筛选条件'
    }),
    filters: localize({
        ru: 'фильтры',
        en: 'filters',
        cn: ''
    }),
}

const expanded = ref(true);
</script>

<style lang="scss">

.z-filter {
    $parent: &;
    max-width: 100%;
    padding: var(--spacer-2xl);

    color: var( --color-black-90);
    border-radius: 30px;
    border: 1px solid var(--color-surface-dim-primary);

    background: linear-gradient(0deg, rgba(230, 240, 237, 0.10) 29.37%, rgba(2, 105, 88, 0.10) 100%), #FFF;
    backdrop-filter: blur(20px);

    position: relative;
    z-index: 3;

    @include breakpoint(mobile){
        padding: var(--spacer-m);
    }

    .row {
        @include margin-level(top, XS, true);

        > [class*="col-"] {
            @include margin-level(top, XS);
        }
    }

    &__title-wrapper {
        @include breakpoint(mobile) {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    &__title {
        color: var(--color-primary);
        display: flex;
        align-items: center;
        flex: 1;
    }

    &__title::after {
        content: "";
        display: block;
        margin: 0 var(--spacer-2xs);
        transition: all .4s ease-in-out;
        height: 1px;
        min-width: 1.67em;
        flex-grow: 1;
        background: currentColor;

        @include breakpoint(mobile) {
            display: none;
        }
    }

    &__toggle-label {
        display: flex;
        align-items: center;
        gap: var(--spacer-3xs);

        cursor: pointer;
        user-select: none;

        @include breakpoint(mobile) {
            width: 100%;
            justify-content: space-between;
        }

        & .z-caption {
            margin-bottom: 0;
        }

        & .z-icon {
            transition: transform .5s ease-in-out;
        }
    }

    &__toggle-label > * {
        color: var(--color-primary) !important;
        margin: 0;
    }


    .slide-down-enter-active,
    .slide-down-leave-active {
        transition: all 0.5s ease;
        overflow: hidden;
    }
    .slide-down-enter-to,
    .slide-down-leave-from{
        height: 300px;

    }
    .slide-down-enter-from,
    .slide-down-leave-to {
        height: 0;
    }
}
body.green .z-filter .z-caption {
    color: var( --color-primary);
}
</style>
